import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RepositoryService} from "../../services/repository.service";

@Component({
  selector: 'app-video-playback',
  templateUrl: './video-playback.component.html',
  styleUrls: ['./video-playback.component.scss']
})
export class VideoPlaybackComponent implements OnInit {

  @Input()
  inProgress: boolean;

  @Input()
  videoUrl: string;

  @Output()
  onBack = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

}
